import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
Vue.use(ElementUI)
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/init.css';
import axios from './utils/axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
const config = require('@/../vue.config');
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
Vue.component('Treeselect',Treeselect);

import buttonCollection from '@/components/buttonCollection'
Vue.component('button-collection',buttonCollection);

import pagination from '@/components/pagination'
Vue.component('pagination',pagination);

import upload from '@/components/upload';
Vue.component('upload',upload);

import tinymce from '@/components/tinymce/index.vue'
Vue.component('tinymce', tinymce)


import {removeByIndex,getTime,router_url,hasBtn,transListDataToTreeData} from './utils/index'

import {get,post,put,export_blob,del} from './api/index'
Vue.prototype.hasBtn = hasBtn
Vue.prototype.removeByIndex = removeByIndex
Vue.prototype.transListDataToTreeData = transListDataToTreeData
Vue.prototype.getTime = getTime
Vue.prototype.router_url = router_url
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$put = put
Vue.prototype.$export_blob = export_blob
Vue.prototype.$del = del

import vuescroll from "vuescroll";
Vue.use(vuescroll, {
  ops: {
  	vuescroll:{wheelScrollDuration:200 },
		bar: {background: "#c1c1c1", keepShow: true},
		scrollPanel: {scrollingX: false, easing:'easeInQuad'}
	},
  name: 'vueScroll'
});

import router from './permission' // 权限
new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js